module.exports = __webpack_public_path__ + "static/media/bg-header-HRF.e3d87ab0.png";